import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const StyledLink = styled.a`
  display: flex;
  margin: 0 auto;
  width: 100%;
  max-width: ${unitizedPx(41)};
`;
